import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  openId: '',
  partnerName: '',
  roleCodeList: [],
  userInfo: {},
  achievementRate: 1,
  capacityPerCustomerTarget: 2200
}

const getters = {
  partnerName: state => state.partnerName,
  roleCodeList: state => state.roleCodeList,
  userInfo: state => state.userInfo,
  achievementRate: state => state.achievementRate,
  capacityPerCustomerTarget: state => state.capacityPerCustomerTarget
}

const mutations = {
  setOpenId(state, openId) {
    state.openId = openId
  },
  setPartnerName(state, partnerName) {
    state.partnerName = partnerName
  },
  setRoleCodeList(state, roleCodeList) {
    state.roleCodeList = roleCodeList
  },
  setUserInfo(state, userInfo) {
    state.userInfo = userInfo
  },
  setAchievementRate(state, achievementRate) {
    state.achievementRate = achievementRate
  },
  setCapacityPerCustomerTarget(state, capacityPerCustomerTarget) {
    state.capacityPerCustomerTarget = Number(capacityPerCustomerTarget)
  }
}

const actions = {}

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions
})
